import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface ForwardProps {
  path: string;
}

export default function Forward(props: ForwardProps) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(props.path);
  });

  return <div />;
}
